function exists(val) {
  return typeof val !== 'undefined' && val !== null;
}

const empty = (target) => {
  if (!exists(target)) {
    return true;
  }

  const targetType = typeof target;

  if (targetType === 'string' && target.trim().length === 0) {
    return true;
  }

  const targetIsObject = targetType === 'object';
  const targetIsArray = Array.isArray(target);

  if (targetIsObject && targetIsArray && target.length === 0) {
    return true;
  }

  if (targetIsObject && !targetIsArray && Object.keys(target).length === 0) {
    return true;
  }

  return false;
};

export default empty;
